import { States } from 'safe'
import {
  CLEAN_SELLS,
  SellsTypes,
  SET_SELLS,
  UPDATE_SALE,
} from '../actions/actionTypes'

const initialState: States.Sells = {
  sells: [],
  numberOfPages: 0,
}

export default (state = initialState, action: SellsTypes): States.Sells => {
  switch (action.type) {
    case SET_SELLS:
      return {
        sells: action.payload.sells,
        numberOfPages: action.payload.numberOfPages,
      }
    case UPDATE_SALE:
      let sellsCopy = [...state.sells]
      let idx = sellsCopy.findIndex((sell) => sell.id === action.payload)
      sellsCopy[idx].invoice.refund = true
      return {
        ...state,
        sells: sellsCopy,
      }
    case CLEAN_SELLS:
      return {
        sells: [],
        numberOfPages: 0,
      }
    default:
      return state
  }
}
